import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import { SERIES_DETAIL_LOGO_IMAGE, renderImage } from 'helpers/ImageHelper';
import { helperGetRelativeUrl } from 'helpers/RouteHelper';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';

import Style from './TitleLink.module.scss';

const TitleLink = ({ breakpoint, episode = {}, item = {} }) => {
  const { screenUrl, name } = item;
  const url = helperGetRelativeUrl({ url: screenUrl });
  const showLogoPath = isMobileBreakpoint(breakpoint) ? 'images.logoCenter.raw' : 'images.logo.raw';
  const altTextPath = isMobileBreakpoint(breakpoint)
    ? 'images.logoCenter.altText'
    : 'images.logo.altText';

  const showLogo = _.get(episode, showLogoPath) || _.get(item, showLogoPath);
  const altText = _.get(episode, altTextPath) || _.get(item, altTextPath) || name;

  const imageLogo = renderImage({
    alt: altText,
    breakpoint,
    imageType: SERIES_DETAIL_LOGO_IMAGE,
    src: showLogo,
    lazyLoad: false,
  });

  return showLogo ? (
    <h1 className={Style.logoContainer}>
      <Link to={url} className={Style.titleLink}>
        {imageLogo}
      </Link>
      <span className={Style.altLogo}>{name}</span>
    </h1>
  ) : (
    <h1 className={Style.logoContainer}>
      <Link to={url} className={Style.titleLink}>
        {name}
      </Link>
    </h1>
  );
};

TitleLink.propTypes = {
  breakpoint: PropTypes.string,
  item: PropTypes.shape({
    screenUrl: PropTypes.string,
    name: PropTypes.string,
  }),
  episode: PropTypes.shape({}),
};

export default TitleLink;
